exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-custom-history-field__label{font-weight:600}", ""]);

// exports
